var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1701",
    "data-name": "Group 1701",
    transform: "translate(-1290 -457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye",
    "data-name": "Icon feather-eye",
    transform: "translate(1299.5 465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12168",
    "data-name": "Path 12168",
    d: "M1.5,12.2S4.6,6,10.03,6s8.53,6.2,8.53,6.2-3.1,6.2-8.53,6.2S1.5,12.2,1.5,12.2Z",
    fill: "none",
    stroke: "#5dadae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12169",
    "data-name": "Path 12169",
    d: "M18.153,15.826A2.326,2.326,0,1,1,15.826,13.5,2.326,2.326,0,0,1,18.153,15.826Z",
    transform: "translate(-5.797 -3.623)",
    fill: "none",
    stroke: "#5dadae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_959",
    "data-name": "Rectangle 959",
    transform: "translate(1290 457)",
    fill: "none",
    stroke: "#5dadae",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.8ec9198113bcbb7c6e6b872eb14a1d5d.svg";
export { ForwardRef as ReactComponent };